<img src="assets/images/error-graphic.svg" alt="Something went wrong">

<h1>Something went wrong</h1>

<p>Please try again later</p>

<p class="reason" *ngIf="reason$ | async as reason">{{reason}}</p>
